
import Vue from 'vue';
import Wrapper from './styles';

export default Vue.extend({
  name: 'RadioButton',
  model: {
    prop: 'choice',
    event: 'change',
  },
  components: {
    Wrapper,
  },
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Label',
    },
    name: {
      type: String,
      default: '',
    },
    value: String,
    choice: String,
  },
});
